import {message} from 'antd';
import config from '../../config'

const loginApi = config['apiServerUrl']+config['loginUrl'];

const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_ERROR: 'LOGIN_ERROR',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (username, password) => {
    return dispatch => {
      dispatch(request({ username }));
      
      fetch(loginApi, {
              method: 'POST',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({"username": username, "password": password}),
          }).then((res)=> res.json())
          .then(
            user => { 
                if (user.is_valid) {
                    dispatch(success(user));
                    localStorage.setItem("id_token",user.token);
                    localStorage.setItem("user_type",user.user_type);
                } else {
                    dispatch(failure("Invalid Username/Password"));
                    localStorage.removeItem("id_token");
                    localStorage.removeItem("user_type");
                    message.error("Invalid Username/Password");
                }
                
            },
            error => {
                dispatch(failure(error.toString()));
                message.error(error.toString());
            });
  };

  function request(user) { return { type: actions.LOGIN_REQUEST, user } }
  function success(user) { return { type: actions.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: actions.LOGIN_FAILURE, error } }
},
  logout: () => ({
    type: actions.LOGOUT
  })
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js